module.exports = __webpack_public_path__ + "static/media/girl.7dc3b851.JPG";